/* eslint-disable @typescript-eslint/naming-convention */
export enum timeFormatsEnum {
    twelveHour = 1,
    twentyFourHour = 2
}
